import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useDocument } from "../../../../hooks/query";
import { API_ENDPOINTS } from "../../../../constants";

export default function useClaimsEstimate() {
    const { id: projectId } = useParams();
    const { useList } = useDocument();
    const listDocListSvc = useList();

    const [claimsEstimateDocument, setClaimsEstimateDocument] = useState<any | null>(null);

    const getDocumentStatus = async () => {
        try {
            if (!projectId) {
                return;
            }
            const response = await listDocListSvc.mutateAsync({ ProjectId: projectId });
            const doc = response.find((document: any) => document.Name === "CLAIMS_ESTIMATE");
            
            if (doc) {
                const imageUrl = API_ENDPOINTS.asset.getImageAsSrc(doc.ThumbnailAssetId);
                doc.thumbnailUrl = imageUrl;
            }
            setClaimsEstimateDocument(doc);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getDocumentStatus().then();
    }, [projectId]);

    return {
        claimsEstimateDocument,
        refreshClaimsEstimate: getDocumentStatus,
    };
}
